import { selectHasNewObject } from './newObject';
import { offerSelector } from './offerData';
import { IState } from '../store';
import { getOfferType, isSuburban, isUrban } from '../utils/offer_type';

export const selectIsRouteMapTabEnabled = (state: IState): boolean => {
  const offer = offerSelector(state);
  const offerType = getOfferType(offer);
  const hasNewObject = selectHasNewObject(state);

  return (isSuburban(offerType) || isUrban(offerType)) && !hasNewObject;
};
